import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { GlobalResponse } from '@app/shared-module/models';
import { InventoryService } from '../inventory.service';
import { Constants } from '@app/shared-module/constants';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-consume-dialog',
  templateUrl: './consume-dialog.component.html',
  styleUrls: ['./consume-dialog.component.css'],
})
export class ConsumeDialogComponent implements OnInit {

  public confirmMessage: string;
  public successButton = 'Confirm';
  public cancelButton = 'Cancel';
  public clinicId: string;
  qty = 0;
  inventoryCache: any = {} as any;
  nameData: any[] = [];
  name_selected: any;
  category: string;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    private toastr: ToastrService,
    private service: InventoryService,
    public dialogRef: MatDialogRef<ConsumeDialogComponent>) { }
  ngOnInit() {
    this.categoryChanged();
  }
  onConfirm() {
    if (this.name_selected && this.name_selected.name && this.name_selected.name !== '') {
      if (this.qty && this.qty > 0) {
        this.dialogRef.close({ qty: this.qty, itemId: this.name_selected._id });
      } else {
        this.toastr.error('Quantity cannot be empty');
      }
    } else {
      this.toastr.error('Name cannot be empty');
    }
  }
  categoryChanged() {
    this.nameData = [];
    this.blockUI.start();
    this.service.getDrugList(this.clinicId, this.category, 0, 0)
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.nameData = res.result.drugs;
        }
      });
  }

  onNameChange = event => {
    // console.log(this.name_selected);
    if (this.name_selected && this.name_selected.name !== 'Select') {
      if (this.name_selected.qty) {
        this.qty = 0;
      }
    } else {
      this.name_selected = { _id: null, name: 'Select' };
      this.qty = 0;
    }
  }
}
